import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop() {
  const [isVisible, setIsVisible] = useState(false);
  const location = useLocation();

  // Show/hide floating button based on scroll position
  useEffect(() => {
    const listenToScroll = () => {
      const heightToShowFrom = 100;
      const winScroll =
        document.body.scrollTop ||
        document.documentElement.scrollTop ||
        window.scrollY ||
        0;

      setIsVisible(winScroll > heightToShowFrom);
    };

    window.addEventListener("scroll", listenToScroll);
    return () => window.removeEventListener("scroll", listenToScroll);
  }, []);

  // Automatically scroll to top whenever the route (pathname) changes
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [location.pathname]);

  return isVisible ? (
    <div className="fixed bottom-12 right-10">
      {/* Floating scroll-to-top button reserved for later */}
    </div>
  ) : null;
}
